import styled from "styled-components";
import { sectionHeading } from "../../components/Typography/Headings";

export const Label = styled.label`
  ${sectionHeading}
  color: ${({ theme }) => theme.palette.sand100};
  margin-bottom: 20px;
  display: block;
  font-size: 12px;
`;
